import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from '../../../generic-components/Icon';
import accountIcon from '../../../assets/icons/svg/stamp-icons/ic-stamp-bank.svg';
import Heading from '../../../generic-components/Heading';
import Button from '../../../generic-components/Button';

interface IProps {
  title: string;
  isLoading: boolean;
  handleUnlink: () => void;
  handleUserMessageClick: () => void;
}

export const UnLinkAccountConfirmation = ({ title, isLoading, handleUnlink, handleUserMessageClick }: IProps) => {
  const { t } = useTranslation();
  return (
    <div className='w-[400px] h-[485px] rounded-lg bg-bw02 flex flex-col items-center px-[42px] pt-[80px] pb-[32px]'>
      <Icon src={accountIcon} className='w-[80px] mb-[50px]' />
      <Heading
        title={t('ADD_MONEY_POST_LINK_UNLINK_CONFIRMATION_HEADER')}
        className='font-metric text-base text-bw08'
      />
      <Heading title={`${title}?`} className='font-metric text-base text-bw08 mb-[104px]' />
      <Button
        disable={isLoading}
        isLoading={isLoading}
        title={t('ADD_MONEY_POST_LINK_UNLINK_CONFIRMATION_CTA_1')}
        onClick={() => handleUnlink()}
        className='w-[240px] text-sm text-bw00 bg-action03 h-12 rounded font-metricBold mb-[16px]'
        id='unlink-account'
      />
      <Button
        onClick={() => handleUserMessageClick()}
        title={t('ADD_MONEY_POST_LINK_UNLINK_CONFIRMATION_CTA_2')}
        className='font-metric text-[13px] text-bw05'
        id='cancel-unlink'
      />
    </div>
  );
};
